<template>
  <transition>
    <div>
      <div class="modal">
        <svg class="modal__cross" @click="$emit('close')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
        </svg>
        <div class="modal__wrapper">
          <div class="add-shortlink_title">
            <span>Создание рекламной кампании</span>
          </div>
          <div class="modal__content flex">
            <div class="flex-item--75">
              <div>
                Наименование
                <span v-if="!validParam.name && !promo.name" class="add-shortlink__valid">
                  Введите наименование пакета
                </span>
              </div>
              <input type="text" v-model="promo.name" class="add-shortlink_input"
                :class="{ 'add-shortlink__error': !validParam.name && !promo.name }" placeholder="Наименование" />
            </div>
            <div class="flex-item--25">
              <div class="add-shortlink_item">
                <div>
                  Бюджет
                </div>
                <input type="number" v-model="promo.budget" class="add-shortlink_input"
                  :class="{ 'add-shortlink__error': !validParam.budget && !promo.budget }"
                  placeholder="Введите бюджет" />
              </div>
            </div>
            <div class="flex-item--full flex">
              <div class="flex-item--50">
                <div>
                  Дата
                </div>
                <input type="datetime-local" v-model="promo.dateFrom" class="add-shortlink_input"
                  placeholder="Дата от" />
              </div>
              <div class="flex-item--50">
                <input type="datetime-local" v-model="promo.dateTo" class="add-shortlink_input" placeholder="Дата до" />
              </div>
            </div>
            <div class="flex-item--50">
              <div>
                Тип пакета
                <span v-if="!validParam.type && !promo.type" class="add-shortlink__valid">
                  Выберите тип пакета
                </span>
              </div>
              <select v-model="promo.type" class="input_box add-shortlink_select" @change="getMechanics"
                :class="{ 'add-shortlink__error': !validParam.type && !promo.type }">
                <option v-for="type in types" :key="type.Id" :value="type.Id"> {{ type.Name }}
                </option>
              </select>
            </div>
            <div class="flex-item--50" v-if="promo.type !== null">
              <div>
                Механика пакета
                <span v-if="!validParam.mechanic && !promo.mechanic" class="add-shortlink__valid">
                  Выберите механику
                </span>
              </div>
              <select v-model="promo.mechanic" class="input_box add-shortlink_select"
                :class="{ 'add-shortlink__error': !validParam.mechanic && !promo.mechanic }">
                <option v-for="mechanic in mechanics" :key="mechanic.Id" :value="mechanic.Id"> {{ mechanic.Name }}
                </option>
              </select>
            </div>
            <div class="flex-item--full grid-col-2">
              <div class="full-row">
                Основной пакет
                <span v-if="!validParam.books && !books.filter(Boolean).length" class="add-shortlink__valid">
                  Добавьте книги
                </span>
              </div>
              <input type="text" v-for="key in books.length" v-model="books[key]" class="add-shortlink_input"
                :class="{ 'add-shortlink__error': !validParam.books && !books.filter(Boolean).length }"
                style="margin-bottom: 8px;" placeholder="Вставьте ASE" @paste.prevent="logger($event)" />
            </div>
            <div class="full-row">
              <label for="listASE" class="source-item">Загрузить файлом XLSX</label>
              <input type="file" id="listASE" name="listASE" @change="handleAseUpload"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="visibility: hidden;">
            </div>
          </div>
          <div class="flex-item--full" style="text-align: right;">
            <button class="btn btn--main" type="submit" @click="createPromo">
              Создать промопакет
            </button>
          </div>
        </div>
      </div>
      <div class="overlay overlay-modal" @click="$emit('close')"></div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      promo: {
        // id: '',
        name: '',
        dateFrom: null,
        dateTo: null,
        budget: '',
        type: null,
        mechanic: null,
        username: null
      },
      books: [''],
      types: [],
      mechanics: [],
      mechanic: null,
      mediaLinkId: '',
      accountLink: '',
      validParam: {
        name: true,
        budget: true,
        type: true,
        mechanic: true,
        books: true
      },
    }
  },
  methods: {
    getMechanics() {
      this.promo.mechanic = null
      this.$axios.get(`https://es.ast.ru/CreatePacket/GetMechanics?type=${this.promo.type}`)
        .then(res => {
          this.mechanics = res.data
          if (this.mechanics.length === 1) this.promo.mechanic = this.mechanics[0].Id
        })
    },
    createPromo() {
      this.valid()
      if (!Object.values(this.validParam).every((i) => !!i)) return ''
      this.promo['username'] = localStorage.getItem('email')
      let books = this.books.filter(Boolean)
      this.$axios.post(`https://es.ast.ru/CreatePacket/SavePromoPacket`, { ...this.promo, books })
        .then((answer) => {
          this.$emit('showNotification', answer)
        })
        .then(() => this.$emit('close'))
        .catch((err) => {
          err.response !== undefined
            ? this.$emit('showNotification', err.response)
            : this.$emit('showNotification', { status: 0, data: 'Произошла неизвестная ошибка' })
        })
    },
    valid() {
      Object.keys(this.validParam).forEach(key => {
        if (key === 'books') this.validParam[key] = !!this.books.filter(Boolean).length
        else this.validParam[key] = !!this.promo[key]
      })
    },
    logger(a) {
      const clipboardData = a.clipboardData
      const pastedText = clipboardData.getData('text')

      // Парсим
      const result = this.parseAndValidateASECodes(pastedText)

      if (result.valid) {
        if (result.count < 0) return false

        let cleanAES = this.books.filter(Boolean)
        this.books = [''].concat(cleanAES, result.codes)
        console.log(this.books)
      } else {
        console.warn('Ошибка парсинга:', result.error)
        a.target.value = pastedText
        return []
      }
    },
    handleAseUpload() {

    },
    parseAndValidateASECodes(text) {
      const codes = text
        .trim()
        .split(/\s+/)
        .map(code => code.trim())
        .filter(code => code !== '')

      // Проверяем, что все коды начинаются с ASE
      const invalidCodes = codes.filter(code => !code.startsWith('ASE'))

      if (invalidCodes.length > 0) {
        return {
          valid: false,
          error: `Найдены некорректные коды: ${invalidCodes.join(', ')}`,
          codes: []
        }
      }

      return {
        valid: true,
        codes: codes,
        count: codes.length,
      }
    }
  },
  mounted() {
    this.$axios.get('https://es.ast.ru/CreatePacket/GetTypes')
      .then(res => this.types = res.data)
  }
}
</script>

<style>
.grid-col-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 8px;
}

.grid-col-2 .full-row {
  grid-column: 1/3;
}
</style>